export default function DefaultFormatter(value) {
  if (!value) {
    return '--'
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  return value
}
